import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { MainLayout } from '@/layouts/MainLayout';
import { AdminLayout } from '@/layouts/AdminLayout';
import { AuthProvider } from '@/contexts/AuthContext';
import { ProtectedRoute } from '@/components/ProtectedRoute';

// Public Pages
import HomeNew from '@/pages/HomeNew';
import Devis from '@/pages/Devis';
import Simulateur from '@/pages/Simulateur';
import Merci from '@/pages/Merci';
import RenovationComplete from '@/pages/RenovationComplete';
import RenovationPartielle from '@/pages/RenovationPartielle';
import CarrelageRevetements from '@/pages/CarrelageRevetements';
import Sanitaires from '@/pages/Sanitaires';
import Plans3D from '@/pages/Plans3D';
import Galerie from '@/pages/Galerie';
import APropos from '@/pages/APropos';
import CGV from '@/pages/CGV';
import MentionsLegales from '@/pages/MentionsLegales';

// Admin Pages
import AdminLogin from '@/pages/admin/Login';
import AdminDashboard from '@/pages/admin/Dashboard';
import AdminLeads from '@/pages/admin/Leads';
import AdminGallery from '@/pages/admin/Gallery';
import AdminSettings from '@/pages/admin/Settings';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={
            <MainLayout>
              <HomeNew />
            </MainLayout>
          } />
          <Route path="/devis" element={
            <MainLayout>
              <Devis />
            </MainLayout>
          } />
          <Route path="/simulateur" element={
            <MainLayout>
              <Simulateur />
            </MainLayout>
          } />
          <Route path="/merci" element={
            <MainLayout>
              <Merci />
            </MainLayout>
          } />
          <Route path="/renovation-complete" element={
            <MainLayout>
              <RenovationComplete />
            </MainLayout>
          } />
          <Route path="/renovation-partielle" element={
            <MainLayout>
              <RenovationPartielle />
            </MainLayout>
          } />
          <Route path="/carrelage-revetements" element={
            <MainLayout>
              <CarrelageRevetements />
            </MainLayout>
          } />
          <Route path="/sanitaires" element={
            <MainLayout>
              <Sanitaires />
            </MainLayout>
          } />
          <Route path="/plans-3d" element={
            <MainLayout>
              <Plans3D />
            </MainLayout>
          } />
          <Route path="/galerie" element={
            <MainLayout>
              <Galerie />
            </MainLayout>
          } />
          <Route path="/a-propos" element={
            <MainLayout>
              <APropos />
            </MainLayout>
          } />
          <Route path="/cgv" element={
            <MainLayout>
              <CGV />
            </MainLayout>
          } />
          <Route path="/mentions-legales" element={
            <MainLayout>
              <MentionsLegales />
            </MainLayout>
          } />

          {/* Admin Login (Public) */}
          <Route path="/admin/login" element={<AdminLogin />} />

          {/* Admin Routes (Protected) */}
          <Route path="/admin/dashboard" element={
            <ProtectedRoute>
              <AdminLayout>
                <AdminDashboard />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/leads" element={
            <ProtectedRoute>
              <AdminLayout>
                <AdminLeads />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/gallery" element={
            <ProtectedRoute>
              <AdminLayout>
                <AdminGallery />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/settings" element={
            <ProtectedRoute>
              <AdminLayout>
                <AdminSettings />
              </AdminLayout>
            </ProtectedRoute>
          } />
          
          {/* Admin Root Redirect */}
          <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />
        </Routes>
        
        <Toaster 
          position="top-center"
          toastOptions={{
            style: {
              background: 'white',
              color: '#2B2B2B',
              border: '1px solid #e2e8f0',
            },
            className: 'sonner-toast',
          }}
        />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;